module.exports = __webpack_public_path__ + "static/media/logo.56aaed30.png";